import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import metadata from './HealthClubFacilityComponent.metadata.json5';
import styles from '../../../SpaAndWellCommonStyles.module.scss';
import QuantityComponent from '../subcomponents/Quantity/QuantityComponent';
import PercentageComponent from '../subcomponents/Percentage/PercentageComponent';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function HealthClubFacilityComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('HealthClubFacilityComponent');

    const modelVM = _.get(submissionVM, pathUpdated);

    modelVM.value.isValidationReq = true;

    const isNumberOfCourtsVisible = () => {
        let couFie = false;

        if ((!_.isUndefined(modelVM.value.basCouFie) && modelVM.value.basCouFie) 
            || (!_.isUndefined(modelVM.value.racCouFie) && modelVM.value.racCouFie)
            || (!_.isUndefined(modelVM.value.squCouFie) && modelVM.value.squCouFie)) {
                couFie = true;
            }

        return couFie;
    }


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        actappisengOthexpFie: {
            visible: !_.isUndefined(modelVM.value.othFie) && modelVM.value.othFie
        },
        numofCouFie: {
            visible: isNumberOfCourtsVisible()
        },
        supRatFie: {
            visible: !_.isUndefined(modelVM.value.chiMinFie) && modelVM.value.chiMinFie
        },
        doyouprotratostuFie: {
            visible: !_.isUndefined(modelVM.value.doetheInsprotraFie) && modelVM.value.doetheInsprotraFie,
            defaultValue: false
        },
        phyFie: {
            visible: !_.isUndefined(modelVM.value.doethefacoffphyFie) && modelVM.value.doethefacoffphyFie
        },
        ifYespleelaFie: {
            visible: !_.isUndefined(modelVM.value.aretheanyopeawafropreFie) && modelVM.value.aretheanyopeawafropreFie
        },
        ifYespleprolisFie: {
            visible: !_.isUndefined(modelVM.value.weaFie) && modelVM.value.weaFie
        },
        numofTonBedFie: {
            visible: !_.isUndefined(modelVM.value.tonBedFie) && modelVM.value.tonBedFie
        },
        quantityComponent: {
            data: modelVM.quantityDTO,
            updateWizardData,
            submissionVM,
            QuantityPath: `${pathUpdated}.quantityDTO`
        },
        percentageComponent: {
            data: modelVM.percentageDTO,
            updateWizardData,
            submissionVM,
            PercentagePath: `${pathUpdated}.percentageDTO`
        },
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            quantityComponent: QuantityComponent,
            percentageComponent: PercentageComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

HealthClubFacilityComponent.propTypes = wizardProps;
export default withRouter(HealthClubFacilityComponent);
